export interface SurveyField {
  id: string;
  section: string;
  prompt: string;
  required: string;
  cms_ids: string[];
  custom_option_labels: string[];
  presenter: string;
  type: string;
}

export enum SurveyFieldType {
  RADIO = 'radio',
  TEXT = 'text',
}

export enum RegionID {
  JP = 'JP',
  EU = 'EU',
  NA = 'NA',
  TW = 'TW',
}
